module.exports = __webpack_public_path__ + "img/Itel.231.ecb227f9.png";